<script lang="ts">
	import { type Achievement, AchievementProgressState } from '../../../../domain/Achievement';
	import { page } from '$app/state';

	export let achievement: Achievement;

	const isAchievementCompleted = achievement.progress.current === achievement.content.card.completionGoal;
	const isAchievementExpired = achievement.progress.state === AchievementProgressState.EXPIRED;

	const initialAngle = 5;
	const completeAngle = 360;

	const progressSize = 68;
	let angle: number;
	if (isAchievementExpired) {
		angle = completeAngle;
	} else if (achievement.progress.current !== 0) {
		angle = completeAngle * (achievement.progress.current / achievement.content.card.completionGoal);
	} else angle = initialAngle;


	let finalColor: string;
	if (isAchievementExpired) {
		finalColor = '#E5E5E5';
	} else if (isAchievementCompleted) {
		finalColor = '#64C8B9';
	} else finalColor = achievement.content.card.progressBarColor;

	$: cssVarStyles = `--color:${finalColor};--degrees:${angle}deg;--progressSize:${progressSize}px;`;
</script>

<div class="oc-mr-75 progress__container"
	data-testid="achievement-progress"
	aria-label={`Challenge-Fortschritt ${achievement.progress.current} von ${achievement.content.card.completionGoal}`}>
	<div data-testid="progress-circle" class="progress__circle" style="{cssVarStyles}">
		<div class="oc-copy-75 circle-text {isAchievementExpired ? 'disabled-text' : '' }">
			{achievement.progress.current}/{achievement.content.card.completionGoal}
		</div>
	</div>
</div>


<style lang="scss">
  $progressSize: var(--progressSize);
  .circle-text {
    display: flex;
    align-items: center;
  }

  .disabled-text {
    color: #949494;
  }

  .progress {
    &__container {
      align-self: flex-start;
    }

    &__circle {
      background: radial-gradient(white 56%, transparent 51%), conic-gradient(#E6E6E6 0deg, #E6E6E6 360deg);
      border-radius: 50%;
      width: $progressSize;
      aspect-ratio: 1;
      position: relative;
      place-content: center;
      display: flex;

      &:before {
        content: "";
        position: absolute;
        border-radius: 50%;
        inset: 0;
        background: radial-gradient(farthest-side, var(--color) 98%, #0000) top/8px 8px no-repeat,
        conic-gradient(var(--color) 0deg, var(--degrees), transparent var(--degrees) 360deg);
        mask: radial-gradient(farthest-side, #0000 calc(99% - 8px), #000 calc(100% - 8px));
      }

      &:after {
        content: "";
        position: absolute;
        border-radius: 50%;
        inset: calc(50% - 8px / 2);
        background: var(--color);
        transform: rotate(var(--degrees)) translateY(calc(50% - $progressSize / 2));
      }
    }


  }

</style>

